var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",staticStyle:{"height":"100%"}},[_c('div',{staticClass:"ezuikit_video",attrs:{"id":_vm.id}})])
}
var staticRenderFns = []

export { render, staticRenderFns }